define(function (require, exports, module) {
    var PatchableApiModel = require('game-data-pacemaker/js/model/PatchableApiModel');

    var Superclass;

    function GumboModel (data) {
        Superclass.constructor.call(this, data);
    }

    PatchableApiModel.spawn(GumboModel);
    Superclass = GumboModel.superclass;
    return GumboModel;
});
